import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
// import { getListProveedor } from "../api/api-equipment-provider";
// import "react-widgets/styles.css";
// import DatePicker from "react-widgets/DatePicker";
import moment from "moment";
import { getListVehiculo, obtenerInfoVehiculo } from "../api/api-vehiculo";
import { getListEquipoCombo } from "../api/api-tracking-device";
import { getListSimCombo } from "../api/api-sim";
import { obtenerListaEmpresaPlataforma } from "../api/api-empresa-plataforma";
import spinner from "../assets/iconos/spinner4.svg";
import { infoInstalacion } from "../api/api-instalacion";
import { getListVendedor } from "../api/api-vendedores";
import { getListMoneda } from "../api/api-moneda";
import { useTipoServicio } from "../utils/const/const-select-tipo-servicio";
// import { getListGrupoByIdEmpresaPlataforma } from "../api/api-grupo";
// import { getListSubGrupoCombo } from "../api/api-sub-grupo";
// import momentLocalizer from "react-widgets-moment";

// new momentLocalizer(moment);

export default function ModalFormInstalacion({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const dateInputRef = useRef(null);

    const SELECT_TIPO_SERVICIO = useTipoServicio();
    const [tipoServicioSelected, setTipoServicioSelected] = useState(null);

    const [listActivo, setListActivo] = useState([]);
    const [activoSelected, setActivoSelected] = useState(null);

    const [listEquipo, setListEquipo] = useState([]);
    const [equipoSelected, setEquipoSelected] = useState(null);

    const [listSim, setListSim] = useState([]);
    const [simSelected, setSimSelected] = useState(null);

    const [listEmpresaPlataforma, setListEmpresaPlataforma] = useState([]);
    const [empresaPlataformaSelected, setEmpresaPlataformaSelected] = useState(null);

    const [listVendedores, setListVendedores] = useState([]);
    const [vendedorSelected, setVendedorSelected] = useState(null);

    const [listaMoneda, setListaMoneda] = useState([]);
    const [monedaSelected, setMonedaSelected] = useState(null);

    // const [listGrupo, setListGrupo] = useState([]);
    const [idGrupo, setIdGrupo] = useState(null);

    // const [listSubGrupo, setListSubGrupo] = useState([]);
    const [idSubGrupo, setIdSubGrupo] = useState(null);

    const [fechaInstalacion, setFechaInstalacion] = useState("");

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);
            const vehiculos = await getListVehiculo({ habilitado: 1 }, true, t);
            setListActivo(vehiculos);
            const listaEquipo = await getListEquipoCombo();
            setListEquipo(listaEquipo);
            const listaSim = await getListSimCombo();
            setListSim(listaSim);
            const empPlataforma = await obtenerListaEmpresaPlataforma({ habilitado: 1 }, true, t);
            setListEmpresaPlataforma(empPlataforma);
            const listVend = await getListVendedor({ habilitado: 1 }, true, t);
            setListVendedores(listVend);

            const listaMon = await getListMoneda({ habilitado: 1 }, true, t);
            setListaMoneda(listaMon);

            // console.log('tipoServicio', SELECT_TIPO_SERVICIO);
            // setTipoServicioSelected(null);
            // setEmpresaPlataformaSelected(null);
            // setVendedorSelected(null);
            // setMonedaSelected(null);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const charLimits = {
        numeroOrdenInstalacion: 128,
        montoInstalacion: 10,
        montoServicio: 10,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    useEffect(() => {
        onChangeEmpresaPlataformaSelected();
    }, [empresaPlataformaSelected]);

    const onChangeEmpresaPlataformaSelected = async () => {
        setIdGrupo(null);
        setIdSubGrupo(null);
    };

    useEffect(() => {
        onChangeActivoSelected();
    }, [activoSelected]);

    const onChangeActivoSelected = async () => {
        if (activoSelected === null) {
            setIdGrupo(null);
            setIdSubGrupo(null);
        }
        if (activoSelected !== null) {
            const resp = await obtenerInfoVehiculo({ id: activoSelected.value });
            console.log('resp', resp);
            setIdGrupo(null);
            setIdSubGrupo(null);
            if (Array.isArray(resp) && resp.length > 0) {
                const data = resp[0];
                setIdGrupo(data.idGrupo);
                setIdSubGrupo(data.idSubgrupo);
            }
            // setListSubGrupo(subGrupo);
        }
    };

    const validateForm = async () => {
        try {
            // console.log('validateForm');
            // console.log(formData);
            setLoading(true);
            // console.log("proveedorSelected", proveedorSelected);
            let message = "";
            if (empresaPlataformaSelected === null || empresaPlataformaSelected === undefined) {
                message = message + "Select Empresa" + '\n';
            }
            if (idGrupo === null || idGrupo === undefined) {
                message = message + "Group not found" + '\n';
            }
            if (idSubGrupo === null || idSubGrupo === undefined) {
                message = message + "SubGroup not found" + '\n';
            }
            if (activoSelected === null || activoSelected === undefined) {
                message = message + t("alert_must_select_unit") + '\n';
            }
            if (equipoSelected === null || equipoSelected === undefined) {
                message = message + "Seleccione Equipo" + '\n';
            }
            if (simSelected === null || simSelected === undefined) {
                message = message + "Seleccione SIM" + '\n';
            }
            if (moment(fechaInstalacion).isValid() === false) {
                message = message + t("alert_invalid_date") + '\n';
            }
            if (String(formData.numeroOrdenInstalacion).trim().length === 0) {
                message = message + "Debe ingresar Numero Orden Instalacion" + '\n';
            }
            if (monedaSelected === null || monedaSelected === undefined) {
                message = message + t("alert_must_select_currency") + '\n';
            }
            if (String(formData.montoInstalacion).trim().length === 0) {
                message = message + t("alert_must_enter_value_currency") + '\n';
            }

            if (tipoServicioSelected === null || tipoServicioSelected === undefined) {
                message = message + t("alert_must_select_tipo_servicio") + '\n';
            }
            if (String(formData.montoServicio).trim().length === 0) {
                message = message + t("alert_must_enter_value_monto_servicio") + '\n';
            }

            if (message.length > 0) {
                alert(message);
                setLoading(false);
                return;
            }
            formData.idVendedor = vendedorSelected !== null ? vendedorSelected.value : null;
            formData.idMoneda = monedaSelected !== null ? monedaSelected.value : null;
            formData.monto = String(formData.montoInstalacion).trim();
            formData.idEmpresaPlataforma = empresaPlataformaSelected.value;
            formData.idGrupo = idGrupo;
            formData.idSubGrupo = idSubGrupo;
            formData.idActivo = activoSelected.label;
            formData.idEquipo = equipoSelected.value;
            formData.idSim = simSelected.value;
            formData.fechaInstalacion = moment(fechaInstalacion).format("YYYY/MM/DD");
            formData.idTipoServicio = tipoServicioSelected?.value;
            formData.montoServicio = String(formData.montoServicio).trim();
            // console.log('formData');
            // console.log(formData);
            // return;
            const resp = await infoInstalacion(formData);
            // console.log('infoInstalacion', resp);
            if (Array.isArray(resp) && resp.length === 0) {
                onConfirm(formData);
            }
            if (Array.isArray(resp) && resp.length > 0) {
                const data = resp[0];
                // console.log('data');
                // console.log(data);
                if (data.fechaDesinstalacion === null) {
                    onConfirm(formData);
                }
                if (moment(data.fechaDesinstalacion).isValid() === true) {
                    onConfirm(formData);
                } else {
                    alert(t("alert_activo_equipo_no_desinstalado"));
                }
            }
            setLoading(false);

        } catch (err) {
            console.log('validateForm err');
            console.log(err);
            setLoading(false);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            id: 0,
            idActivo: null,
            idEquipo: null,
            idSim: null,
            fechaInstalacion: "",
            numeroOrdenInstalacion: "",
            montoInstalacion: 0,
        });
        setFechaInstalacion("");
        setActivoSelected(null);
        setEquipoSelected(null);
        setSimSelected(null);
        onCancel();
        setEmpresaPlataformaSelected(null);
        setIdGrupo(null);
        setIdSubGrupo(null);
    };

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-5/6">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>

                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_company")}<span className="text-red-500">*</span></label>
                                <Select
                                    options={listEmpresaPlataforma}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={empresaPlataformaSelected}
                                    onChange={(event) => setEmpresaPlataformaSelected(event)}
                                    placeholder={t("label_select_company")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_seller")}</label>
                                <Select
                                    options={listVendedores}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={vendedorSelected}
                                    onChange={(event) => setVendedorSelected(event)}
                                    placeholder={t("label_select_seller")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_select_activo")}<span className="text-red-500">*</span></label>
                                <Select
                                    options={listActivo}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={activoSelected}
                                    onChange={(event) => setActivoSelected(event)}
                                    placeholder={t("label_select_activo")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{'EQUIPO'}<span className="text-red-500">*</span></label>
                                <Select
                                    options={listEquipo}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={equipoSelected}
                                    onChange={(event) => setEquipoSelected(event)}
                                    placeholder={"Select Equipo"}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{'SIM'}<span className="text-red-500">*</span></label>
                                <Select
                                    options={listSim}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={simSelected}
                                    onChange={(event) => setSimSelected(event)}
                                    placeholder={"SIM"}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_date_instalation")}: MM/DD/YYYY<span className="text-red-500">*</span></label>
                                <div
                                    className="relative w-full cursor-pointer"
                                    onClick={() => dateInputRef.current?.showPicker()} // Open calendar on click
                                >
                                    <input
                                        type="date"
                                        ref={dateInputRef}
                                        value={fechaInstalacion}
                                        onChange={(e) => {
                                            // console.log('date:', e.target.value);
                                            setFechaInstalacion(e.target.value);
                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_order_number_install")}<span className="text-red-500">*</span></label>
                                <input
                                    name="numeroOrdenInstalacion"
                                    value={formData.numeroOrdenInstalacion}
                                    onChange={handleInputChange}
                                    placeholder={t("enter_order_number")}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.numeroOrdenInstalacion.length}/{charLimits.numeroOrdenInstalacion}</p>
                            </div>
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_currency")}<span className="text-red-500">*</span></label>
                                <Select
                                    options={listaMoneda}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={monedaSelected}
                                    onChange={(event) => setMonedaSelected(event)}
                                    placeholder={t("label_select")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_instalacion_monto")}<span className="text-red-500">*</span></label>
                                <input
                                    type="number"
                                    name="montoInstalacion"
                                    value={formData.montoInstalacion}
                                    onChange={handleInputChange}
                                    placeholder={t("label_enter_value")}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.montoInstalacion?.length}/{charLimits.montoInstalacion}</p>
                            </div>
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_instalacion_monto_servicio")}<span className="text-red-500">*</span></label>
                                <input
                                    type="number"
                                    name="montoServicio"
                                    value={formData.montoServicio}
                                    onChange={handleInputChange}
                                    placeholder={t("label_enter_value")}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.montoServicio?.length}/{charLimits.montoServicio}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                                <label className="block text-gray-600 font-semibold mb-1">{t("label_tipo_servicio")}<span className="text-red-500">*</span></label>
                                <Select
                                    options={SELECT_TIPO_SERVICIO}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={tipoServicioSelected}
                                    onChange={(event) => {
                                        // console.log('event', event);
                                        setTipoServicioSelected(event);
                                        // console.log('SELECT_TIPO_SERVICIO', SELECT_TIPO_SERVICIO);
                                    }}
                                    placeholder={t("label_select")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">

                            </div>
                        </div>


                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            {loading === false && (
                                <button
                                    onClick={validateForm}
                                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                                >
                                    Acceptar
                                </button>
                            )}
                            {loading === true && (
                                <button className="login_button flex justify-center">
                                    <img className="spinner"
                                        alt="spinner" src={spinner} />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
